import { Component, OnInit, Inject, Input } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { OregonWellDataService } from '../../../services/oregon-well-data.service';
import { VoucherService } from '../../../services/voucher-service';
import { FormControl, FormGroup } from '@angular/forms';

/*
 * Edit Household Dialog
 */
@Component({
  selector: 'dialog-household-edit',
  templateUrl: 'household-edit-dialog.html',
  styleUrls: ['./household-edit-dialog.scss']
})
export class DialogEditHouseholdComponent implements OnInit {
  @Input('householdId')
  householdId: number = 0;
  loading: boolean = false;
  processing: boolean = false;
  householdForm = new FormGroup({
    id: new FormControl(0),
    contactName: new FormControl(''),
    contactEmail: new FormControl(''),
    contactPhone: new FormControl(''),
    addressUnitNumber: new FormControl(''),
    address1: new FormControl(''),
    address2: new FormControl(''),
    city: new FormControl(''),
    state: new FormControl(''),
    zip: new FormControl(''),
    county: new FormControl(''),
    latitude: new FormControl(0),
    longitude: new FormControl(0),
    personsInHousehold: new FormControl(0),
    pregnancyInHousehold: new FormControl(false),
    comments: new FormControl(''),
    waterTreamentProvided: new FormControl(false),
    bottledWaterProvided: new FormControl(false),
    infantsUnder1: new FormControl(0),
    age1to4: new FormControl(0),
    age5to9: new FormControl(0),
    age10to14: new FormControl(0),
    age15to19: new FormControl(0),
    age20to29: new FormControl(0),
    age30to39: new FormControl(0),
    age40to49: new FormControl(0),
    age50to59: new FormControl(0),
    age60to69: new FormControl(0),
    age70to79: new FormControl(0),
    age80Plus: new FormControl(0),
  });

  constructor(public oregonWellDataService: OregonWellDataService,
    public voucherService: VoucherService,
    private toastr: ToastrService,
    @Inject(MAT_DIALOG_DATA) public data: number,
    private dialogRef: MatDialogRef<DialogEditHouseholdComponent>) {
      this.householdId = this.data;
  }

  ngOnInit(): void {
    // ngOnInit   
  }
}